/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){ .order-type-picker{width:100%}}@media screen and (min-width:600px){ .order-type-picker{width:400px}} .order-type-picker .mat-dialog-container{padding:0} .order-type-picker .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial} .order-type-picker .dialog-content-wrapper{max-height:85vh;display:flex;flex-direction:column} .order-type-picker .order-type-button{margin:10px 0;min-width:100%} .order-type-picker .order-type-button span{white-space:pre-wrap}"];
export { styles as styles };
